import styled from '@emotion/styled';
import React, { forwardRef } from 'react';
import { theme } from 'styles/theme/theme';

/** Все атрибуты `<input>`, кроме `type`. */
export interface UDRadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {}

/**
 * Нативная радиокнопка в цвете акцента темы.
 *
 * Видимый `<input type="radio">`, а не нарисованный кружок: клавиатура (стрелки внутри группы), фокус и роль
 * `radio` остаются браузерными, цвет даёт `accent-color`. Подпись и строку вокруг рисует вызывающий — обычно
 * `<label>` с кнопкой и текстом внутри, тогда клик по подписи выбирает пункт.
 */
const UDRadio = forwardRef<HTMLInputElement, UDRadioProps>(function UDRadio(props, ref) {
  return <Input {...props} ref={ref} type="radio" />;
});

export default UDRadio;

// Специфичность одного класса: экран со своим акцентом (редактор медиа-менеджера) перекрашивает кнопку своим правилом.
const Input = styled.input`
  accent-color: ${theme.colors.AccentNaplesYellow};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;
